<div
	class="button-group {{ type }}"
	matTooltipClass="pv-tooltip"
	matTooltipPosition="right"
	[matTooltip]="help"
	[matTooltipDisabled]="!help"
>
	<button [disabled]="disabled" (click)="clickLeft()"><ng-content /></button>
	<button [disabled]="disabled" (click)="clickRight()">
		<i aria-hidden="true" data-test="createButton" [class]="iconClass"></i>
	</button>
</div>
